import { render, staticRenderFns } from "./projectOutsourcing.vue?vue&type=template&id=02306cf0&scoped=true"
import script from "./projectOutsourcing.vue?vue&type=script&lang=js"
export * from "./projectOutsourcing.vue?vue&type=script&lang=js"
import style0 from "./projectOutsourcing.vue?vue&type=style&index=0&id=02306cf0&prod&scoped=true&lang=css"
import style1 from "./projectOutsourcing.vue?vue&type=style&index=1&id=02306cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02306cf0",
  null
  
)

export default component.exports